/* IM Cart – drawer + réduction + affichage 3POUR2 + variantes propres */
(() => {
  'use strict';

  const $ = (q, c = document) => c.querySelector(q);
  const root = $('#im-cart');
  if (!root) return;

  /* ---------- Raccourcis éléments ---------- */
  const els = {
    items: $('[data-imc-items]', root),
    empty: $('[data-imc-empty]', root),

    // Discount UI
    discRow: $('.imc-row--toggle', root),
    discTog: $('[data-imc-disc-tog]', root) || $('.imc-row--toggle', root), // tolérant
    discPanel: $('#imc-disc-panel', root),
    discInput: $('[data-imc-disc-input]', root),
    discApply: $('[data-imc-disc-apply]', root),
    discHint: $('[data-imc-disc-hint]', root),
    discLine: $('[data-imc-disc-line]', root),
    discCode: $('[data-imc-disc-code]', root),
    discClear: $('[data-imc-disc-clear]', root),

    // Récap
    beforeRow: $('[data-imc-before-row]', root),
    before: $('[data-imc-before]', root),
    discountRow: $('[data-imc-discount-row]', root),
    discAmount: $('[data-imc-disc-amount]', root),

    // Totaux + checkout
    total: $('[data-imc-total]', root),
    count: $('[data-imc-count]', root),
    checkout: $('[data-imc-checkout]', root),
  };

  /* === AJOUT : helper shimmer sur le total === */
  const setTotalLoading = (on) => {
    if (!els.total) return;
    els.total.classList.toggle('imc-total--loading', !!on);
    els.total.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  /* ---------- Helpers ---------- */
  const cur = (window.Shopify?.currency?.active) || 'EUR';
  const money = (cents) => {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: cur }); }
    catch { return (cents / 100).toFixed(2) + ' €'; }
  };

  const labelMap = new Map([
    // normalisations -> étiquettes voulues
    ['s', 'Taille'],
    ['taille', 'Taille'],
    ['nom', 'Nom'],
    ['numero', 'Numéro'],
    ['numéro', 'Numéro'],
    ['name_below', 'Nom en dessous'],
    ['nom_en_dessous', 'Nom en dessous'],
    ['nom_sous_le_numero', 'Nom en dessous'],
    ['nom sous le numéro', 'Nom en dessous'],
  ]);

  const norm = (k) => String(k || '').trim().toLowerCase();

  // Tente d'extraire un pourcentage en fin de code : "EMMA20" -> 20
  const parsePct = (code) => {
    const m = (code || '').match(/(\d{1,2})\D*$/);
    const n = m ? parseInt(m[1], 10) : 0;
    return n > 0 && n <= 90 ? n : 0;
  };

  let cart = { items: [], items_subtotal_price: 0, item_count: 0 };
  let discountCode = (localStorage.getItem('imc_discount_code') || '').toUpperCase();

  // Montants calculés côté affichage
  let estimatedPercentDiscount = 0;   // pour codes % (ex. EMMA20)
  let promo3x2Discount = 0;           // pour 3POUR2 simulation
  let freeUnitsMap = {};              // { line_key: nb d’unités offertes } pour l'affichage ligne

  /* ---------- API Shopify ---------- */
  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function changeQty(key, qty){
    const itemEl = root.querySelector(`.imc-it[data-key="${key}"]`);
    if (!itemEl) return;

    // Optimistic UI sur la LIGNE uniquement (pas de recalcul du total ici)
    if (qty <= 0) {
      itemEl.classList.add('removing');
      setTimeout(() => itemEl.remove(), 150);
    } else {
      const input = itemEl.querySelector('.imc-qty__input');
      if (input) input.value = qty;
    }

    // === AJOUT : shimmer pendant la MAJ serveur + re-render
    setTotalLoading(true);
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
    } catch(e) {
      console.warn('[IMCart] changeQty error', e);
    }
    await render();
    setTotalLoading(false);
  }

  /* ---------- Rendu des propriétés (variante + custom fields) ---------- */
  function renderPropsLine(it) {
    const parts = [];

    // Variante (ex: "S")
    const vt = (it.variant_title || '').trim();
    if (vt) parts.push(`<div class="imc-it__variant">${vt}</div>`);

    // Propriétés custom
    const p = it.properties || {};
    Object.keys(p).forEach((k) => {
      const v = p[k];
      if (v == null || v === '' || v === false) return;
      const keyN = norm(k);
      const label = labelMap.get(keyN) || (k.charAt(0).toUpperCase() + k.slice(1));
      parts.push(`<div class="imc-it__props"><span class="k">${label}:</span> <span class="v">${String(v)}</span></div>`);
    });

    return parts.join('');
  }

  /* ---------- Simulation 3POUR2 (affichage uniquement) ---------- */
  function compute3for2(items) {
    // Reset
    promo3x2Discount = 0;
    freeUnitsMap = {};

    if (!/^3POUR2/i.test(discountCode)) return;

    // Liste des unités éligibles (une entrée par unité)
    // On se base sur le prix "price" (prix unitaire en centimes)
    const units = [];
    items.forEach(it => {
      const unitPrice = (it.price ?? it.final_price ?? 0);
      const q = it.quantity || 0;
      for (let i = 0; i < q; i++) {
        units.push({ key: it.key, unitPrice });
      }
    });

    if (!units.length) return;

    // Tri par prix croissant
    units.sort((a, b) => a.unitPrice - b.unitPrice);

    const numberFree = Math.floor(units.length / 3);
    if (numberFree <= 0) return;

    // Les "numberFree" moins chers deviennent gratuits
    for (let i = 0; i < numberFree; i++) {
      const u = units[i];
      promo3x2Discount += u.unitPrice;
      freeUnitsMap[u.key] = (freeUnitsMap[u.key] || 0) + 1;
    }
  }

  /* ---------- DOM helpers ---------- */
  function show(el, yes) {
    if (!el) return;
    if (yes) {
      el.removeAttribute('hidden');
      el.classList.add('imc-fade--in');
      setTimeout(() => el.classList.remove('imc-fade--in'), 180);
    } else {
      el.setAttribute('hidden', 'hidden');
    }
  }

  /* ---------- Noeud article ---------- */
  function itemNode(it) {
    const t = $('#imc-item', root).content.cloneNode(true);
    const el = t.querySelector('.imc-it');
    el.dataset.key = it.key;

    // Image + titre
    const img = t.querySelector('.imc-it__img');
    img.src = it.image || it?.featured_image?.url || '';
    img.alt = it.product_title || '';

    t.querySelector('.imc-it__title').innerHTML = `${it.product_title || ''} ` + (freeUnitsMap[it.key] ? `<span style="display:inline-block;background:#E8F7ED;color:#15803d;border-radius:999px;padding:4px 8px;font-size:12px;margin-left:6px;">Offert</span>` : '');

    // Variante + propriétés en colonnes
    t.querySelector('[data-imc-props]').innerHTML = renderPropsLine(it);

    // Prix affiché (ligne)
    const pricePerUnit = (it.price ?? it.final_price ?? 0);
    const q = it.quantity || 0;
    const nbFree = freeUnitsMap[it.key] || 0;
    const displayLinePrice = Math.max(0, (q * pricePerUnit) - (nbFree * pricePerUnit));
    t.querySelector('.imc-it__price').textContent = money(displayLinePrice);

    // Contrôles quantité
    const input = t.querySelector('.imc-qty__input');
    input.value = q;
    t.querySelector('.imc-qty--inc').addEventListener('click', () => changeQty(it.key, q + 1));
    t.querySelector('.imc-qty--dec').addEventListener('click', () => changeQty(it.key, Math.max(0, q - 1)));
    t.querySelector('.imc-remove').addEventListener('click', () => changeQty(it.key, 0));
    input.addEventListener('change', (e) => changeQty(it.key, Math.max(0, parseInt(e.target.value || '0', 10))));

    return t;
  }

  /* ---------- Application visuelle des remises ---------- */
  function applyDiscountPreview() {
    estimatedPercentDiscount = 0;

    // Sans code → on masque les lignes récap "Avant / Réduction"
    if (!discountCode) {
      show(els.discLine, false);
      show(els.beforeRow, false);
      show(els.discountRow, false);
      if (els.discHint) els.discHint.hidden = true;
      updateCheckoutLink();
      return;
    }

    // Pourcentage ?
    const pct = parsePct(discountCode);
    if (pct) {
      estimatedPercentDiscount = Math.round(cart.items_subtotal_price * pct / 100);
      if (els.discHint) {
        els.discHint.textContent = `Estimation : ${pct}% appliqués au total. Remise réelle au paiement.`;
        els.discHint.hidden = false;
      }
    } else if (/^3POUR2/i.test(discountCode)) {
      if (els.discHint) {
        els.discHint.textContent = `Offre 3 pour 2 : l’article le moins cher de chaque trio est offert (affichage estimatif).`;
        els.discHint.hidden = false;
      }
    } else {
      if (els.discHint) {
        els.discHint.textContent = `Le code sera appliqué au paiement. Total estimatif.`;
        els.discHint.hidden = false;
      }
    }

    if (els.discCode) els.discCode.textContent = discountCode;

    // Lignes récap visibles
    if (els.before) els.before.textContent = money(cart.items_subtotal_price);
    show(els.beforeRow, true);
    show(els.discountRow, true);
    show(els.discLine, true);

    updateCheckoutLink();
  }

  function updateTotals() {
    // total = sous-total - réduction % estimée - réduction 3x2 simulée
    const total = Math.max(0, cart.items_subtotal_price - (estimatedPercentDiscount || 0) - (promo3x2Discount || 0));

    // Affiche le montant de la ligne "Réductions"
    if (els.discAmount) {
      const disc = (estimatedPercentDiscount || 0) + (promo3x2Discount || 0);
      els.discAmount.textContent = disc > 0 ? `− ${money(disc)}` : '—';
    }

    if (els.total) {
      els.total.textContent = money(total);
      els.total.closest('.imc-row')?.classList.add('imc-fade--in');
      setTimeout(() => els.total.closest('.imc-row')?.classList.remove('imc-fade--in'), 180);
    }
  }

  /* ---------- Checkout + Remise persistante ---------- */
  function updateCheckoutLink() {
    if (!els.checkout) return;

    const enc = discountCode ? encodeURIComponent(discountCode) : '';
    // Utilise /discount/CODE pour poser le cookie Shopify, puis redirige vers /checkout
    const url = discountCode
      ? `/discount/${enc}?redirect=/checkout`
      : `/checkout`;

    els.checkout.setAttribute('href', url);
    els.checkout.onclick = (e) => { e.preventDefault(); location.assign(url); };
  }

  // BLOC 1 — Forcer la remise sur tous les chemins de checkout
  function forceDiscountEverywhere() {
    const enc = discountCode ? encodeURIComponent(discountCode) : '';
    const target = discountCode ? `/discount/${enc}?redirect=/checkout` : `/checkout`;

    // Lien principal du drawer
    els.checkout?.setAttribute('href', target);
    els.checkout?.addEventListener('click', (e) => { e.preventDefault(); location.assign(target); }, { passive: false });

    // Tous les boutons/lien checkout du thème
    document.querySelectorAll('a[href^="/checkout"], button[name="checkout"], input[name="checkout"]').forEach((node) => {
      node.addEventListener('click', (e) => { e.preventDefault(); location.assign(target); }, { passive: false });
    });

    // Soumissions de formulaires /cart → checkout
    document.querySelectorAll('form[action="/cart"]').forEach((form) => {
      form.addEventListener('submit', (e) => {
        if (form.querySelector('[name="checkout"]')) {
          e.preventDefault();
          location.assign(target);
        }
      }, true);
    });
  }

  // BLOC 2 — Primer le cookie de remise (utile pour Shop Pay / paiements accélérés)
  function primeDiscountCookie() {
    if (!discountCode) return;

    // Évite les appels multiples
    if (sessionStorage.getItem('imc_discount_primed') === discountCode) return;
    sessionStorage.setItem('imc_discount_primed', discountCode);

    // Pose le cookie de remise côté Shopify sans quitter la page
    fetch(`/discount/${encodeURIComponent(discountCode)}?redirect=/`, { credentials: 'same-origin' })
      .catch(() => {});
  }

  /* ---------- Rendu global ---------- */
  async function render() {
    cart = await getCart();

    if (els.items) els.items.innerHTML = '';
    if (els.count) els.count.textContent = cart.item_count || 0;

    if (!cart.items.length) {
      if (els.empty) els.empty.hidden = false;
      show(els.beforeRow, false);
      show(els.discountRow, false);
      show(els.discLine, false);
      if (els.total) els.total.textContent = money(0);
      document.dispatchEvent(new CustomEvent('im:cart:updated', { detail: { count: 0 } }));
      return;
    }

    if (els.empty) els.empty.hidden = true;

    // Calcule 3POUR2 si besoin
    compute3for2(cart.items);

    // Items
    cart.items.forEach(it => {
      els.items.appendChild(itemNode(it));
    });

    // Récap remises + total
    applyDiscountPreview();
    updateTotals();

    document.dispatchEvent(new CustomEvent('im:cart:updated', { detail: { count: cart.item_count } }));
  }

  /* ---------- UI : ouvrir/fermer la réduction (ligne entière cliquable) ---------- */
  root.addEventListener('click', (e) => {
    const tog = e.target.closest('[data-imc-disc-tog], .imc-row--toggle');
    if (!tog || !root.contains(tog)) return;

    const opened = els.discPanel.hasAttribute('hidden'); // si hidden => on va ouvrir
    if (opened) {
      els.discPanel.removeAttribute('hidden');
      tog.setAttribute('aria-expanded', 'true');
      tog.querySelector('.imc-disc__icon')?.replaceChildren('−');
    } else {
      els.discPanel.setAttribute('hidden', 'hidden');
      tog.setAttribute('aria-expanded', 'false');
      tog.querySelector('.imc-disc__icon')?.replaceChildren('+');
    }
  });

  /* ---------- Appliquer / Effacer code ---------- */
  els.discApply?.addEventListener('click', () => {
    discountCode = (els.discInput.value || '').trim().toUpperCase();
    localStorage.setItem('imc_discount_code', discountCode);

    // Pose/maj du cookie + sécurisation des chemins de checkout
    primeDiscountCookie();
    updateCheckoutLink();
    forceDiscountEverywhere();

    // === AJOUT : shimmer pendant recalcul
    setTotalLoading(true);
    render().finally(() => setTotalLoading(false));
  });

  els.discClear?.addEventListener('click', () => {
    discountCode = '';
    localStorage.removeItem('imc_discount_code');
    if (els.discInput) els.discInput.value = '';

    // Reset prime + liens
    sessionStorage.removeItem('imc_discount_primed');
    updateCheckoutLink();
    forceDiscountEverywhere();

    // === AJOUT : shimmer pendant recalcul
    setTotalLoading(true);
    render().finally(() => setTotalLoading(false));
  });

  // Entrée dans le champ code = appliquer
  els.discInput?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') { e.preventDefault(); els.discApply?.click(); }
  });

  /* ---------- Drawer open/close ---------- */
  function open() {
    root.classList.add('imc--open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    root.classList.remove('imc--open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  root.addEventListener('click', (e) => {
    if (e.target.matches('[data-imc-close], .imc__backdrop')) close();
  });

  /* ---------- Init ---------- */
  if (discountCode && els.discInput) els.discInput.value = discountCode;
  updateCheckoutLink();
  primeDiscountCookie();
  forceDiscountEverywhere();
  render();

  // API + triggers externes
  window.IMCart = { open: () => render().then(open), close, render };
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-im-open-cart]');
    if (!t) return;
    e.preventDefault();
    IMCart.open();
  });
  document.addEventListener('im:cart:updated', (e) => {
    const el = document.getElementById('im-cart-count');
    if (el) el.textContent = e.detail?.count ?? '';
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();

/* Panier → cacher la bulle à l'ouverture, la remettre à la fermeture */
(() => {
  const cart = document.getElementById('im-cart') || document.querySelector('.imc');
  if (!cart) return;

  // Bubbles connues + fallback heuristique
  const KNOWN = [
    '.shopify-chat-bubble',
    '.gorgias-chat', '#gorgias-chat-container', 'iframe[src*="gorgias"]',
    '.tidio-chat', '#tidio-chat', 'iframe[src*="tidio"]',
    '.crisp-client', 'iframe[src*="crisp"]',
    '.intercom-lightweight-app', 'iframe[src*="intercom"]',
    '#tawkchat-minified', 'iframe[src*="tawk"]',
    '#hubspot-messages-iframe-container', 'iframe[id^="launcher"]'
  ];

  const saved = new WeakMap();

  const collectWidgets = () => {
    const set = new Set();
    KNOWN.forEach(s => document.querySelectorAll(s).forEach(el => set.add(el)));
    // Heuristique : petites bulles fixes bas-droite, z élevé
    document.querySelectorAll('body *').forEach(el => {
      if (!(el instanceof HTMLElement) || cart.contains(el)) return;
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed') return;
      const r = el.getBoundingClientRect();
      const nearBR = (innerWidth - r.right < 180) && (innerHeight - r.bottom < 180);
      const small  = r.width <= 360 && r.height <= 360;
      const zi     = parseInt(cs.zIndex || '0', 10);
      if ((nearBR && small && zi > 1000) || (el.tagName === 'IFRAME' && zi > 1000)) set.add(el);
    });
    return [...set];
  };

  const hide = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) saved.set(el, el.getAttribute('style') || '');
      el.style.cssText += ';opacity:0!important;visibility:hidden!important;pointer-events:none!important;';
    });
  };

  const show = () => {
    collectWidgets().forEach(el => {
      if (!saved.has(el)) return;
      const s = saved.get(el);
      s ? el.setAttribute('style', s) : el.removeAttribute('style');
      saved.delete(el);
    });
  };

  const isOpen = () => {
    const cs = getComputedStyle(cart);
    return cart.classList.contains('imc--open') ||
           cart.classList.contains('is-open') ||
           cart.getAttribute('aria-hidden') === 'false' ||
           cs.display === 'block';
  };

  const sync = () => (isOpen() ? hide() : show());

  // Observe l'état du drawer
  new MutationObserver(sync)
    .observe(cart, { attributes:true, attributeFilter:['class','style','aria-hidden'] });

  // Cliques de fermeture/ouverture courants
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-im-open-cart], .js-open-cart, [href="#cart-drawer"]')) {
      setTimeout(sync, 0);
    }
    if (e.target.closest('[data-imc-close], .imc__backdrop')) {
      setTimeout(sync, 0);
    }
  }, true);

  // Filet périodique (si un script change l'état sans attributs)
  setInterval(sync, 400);

  // Premier passage
  sync();
})();

document.addEventListener('click', async function (event) {
  var modal = document.getElementById('cfCartFranceModal');
  if (!modal) return;

  var openBtn = event.target.closest('[data-cf-france-open]');
  var closeBtn = event.target.closest('[data-cf-france-close]');
  var card = event.target.closest('[data-cf-select-card]');
  var addBtn = event.target.closest('[data-cf-add-selected]');
  var count = modal.querySelector('[data-cf-selected-count]');

  function updateCount() {
    var n = modal.querySelectorAll('[data-cf-select-card].is-selected').length;
    if (count) count.textContent = n + (n > 1 ? ' sélectionnés' : ' sélectionné');
  }

  if (openBtn) {
    event.preventDefault();
    modal.classList.add('is-open');
    updateCount();
  }

  if (closeBtn) {
    event.preventDefault();
    modal.classList.remove('is-open');
  }

  if (card) {
    event.preventDefault();
    card.classList.toggle('is-selected');
    updateCount();
  }

  if (addBtn) {
    event.preventDefault();

    var selected = Array.from(modal.querySelectorAll('[data-cf-select-card].is-selected'));
    if (!selected.length) {
      addBtn.textContent = 'Sélectionne au moins 1 maillot';
      setTimeout(function () {
        addBtn.textContent = 'Ajouter la sélection';
      }, 1400);
      return;
    }

    var items = selected.map(function (el) {
      return {
        id: Number(el.getAttribute('data-variant-id')),
        quantity: 1
      };
    });

    addBtn.textContent = 'Ajout en cours...';

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    localStorage.setItem('imc_discount_code', 'FRANCE');

    modal.classList.remove('is-open');

    var root = document.getElementById('im-cart');
    var input = root ? root.querySelector('[data-imc-disc-input]') : null;
    var apply = root ? root.querySelector('[data-imc-disc-apply]') : null;

    if (input) input.value = 'FRANCE';
    if (apply) apply.click();

    if (window.IMCart && window.IMCart.open) {
      window.IMCart.open();
    }

    selected.forEach(function (el) {
      el.classList.remove('is-selected');
    });

    addBtn.textContent = 'Ajouter la sélection';
    updateCount();
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  var modal = document.getElementById('cfCartFranceModal');
  if (modal) modal.classList.remove('is-open');
});